module.exports = __webpack_public_path__ + "img/duancongmei.91d1cb97.jpg";